import { createSelector } from 'reselect';

const selectCustomers = (state: any) => state.customers;


export const selectCustomersCurrentItem = createSelector([selectCustomers], (customers) => customers.current);

export const selectCustomersListItems = createSelector([selectCustomers], (customers) => customers.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectCustomersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCustomersQueryItems = createSelector([selectCustomers], (customers) => customers.query);

export const selectCustomersCreatedItem = createSelector([selectCustomers], (customers) => customers.create);

export const selectCustomersUpdatedItem = createSelector([selectCustomers], (customers) => customers.update);

export const selectCustomersReadItem = createSelector([selectCustomers], (customers) => customers.read);

export const selectCustomersDeletedItem = createSelector([selectCustomers], (customers) => customers.delete);

export const selectCustomersSearchedItems = createSelector([selectCustomers], (customers) => customers.search);

export const selectCustomersItemsCount = createSelector([selectCustomers], (customers) => customers.count);

export const selectCustomersItemsFilter = createSelector([selectCustomers], (customers) => customers.filter);

export const selectCustomersSummaryItems = createSelector([selectCustomers], (customers) => customers.summary);